import { render, staticRenderFns } from "./PostParamCreate.vue?vue&type=template&id=22a82bd2&scoped=true"
import script from "./PostParamCreate.vue?vue&type=script&lang=js"
export * from "./PostParamCreate.vue?vue&type=script&lang=js"
import style0 from "./PostParamCreate.vue?vue&type=style&index=0&id=22a82bd2&prod&lang=styl&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a82bd2",
  null
  
)

export default component.exports